import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoverComponent } from '@app/client/viewer/cover/cover.component';
import { PreviewComponent } from '@app/client/viewer/preview/preview.component';
import { ViewerComponent } from '@app/client/viewer/viewer.component';
import { VIEWER_ROUTES } from '@app/client/viewer/viewer.routes';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DownloadProgressComponent } from './downloader/download-progress/download-progress.component';
import { DownloaderComponent } from './downloader/downloader.component';
import { ViewerEffects } from './effects';
import { ModalTransferPasswordComponent } from './modals/modal-transfer-password/modal-transfer-password.component';
import { ModalTransferAccessTrackingComponent } from './modals/modal-transfer-access-tracking/modal-transfer-access-tracking.component';
import { DeckComponent } from './preview/deck/deck.component';
import { ModalPreviewComponent } from './modals/modal-preview/modal-preview.component';
import * as fromViewer from './reducers/viewer.reducer';
import { FileCardComponent } from './preview/file-card/file-card.component';
import { SmashHeaderModule } from '@app/shared/modules/smash-header/smash-header.module';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';
import { SmashPlayerModule } from '@app/shared/modules/smash-player/smash-player.module';
import { SmashScrollbarModule } from '@app/shared/modules/smash-scrollbar/smash-scrollbar.module';
import { SmashSnackbarComponent } from './snackbar/smash-snackbar.component';
import { SmashImageModule } from '@app/shared/modules/smash-image/smash-image.module';
import { SwiperConfigInterface, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SmashSwipperModule } from '@app/shared/modules/smash-swipper/smash-swipper.module';
import { SmashPromotionModule } from '@app/shared/modules/smash-promotion/smash-promotion.module';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    ViewerComponent,
    CoverComponent,
    DownloaderComponent,
    DownloadProgressComponent,
    ModalTransferPasswordComponent,
    ModalTransferAccessTrackingComponent,
    PreviewComponent,
    DeckComponent,
    ModalPreviewComponent,
    FileCardComponent,
    SmashSnackbarComponent
  ],
  imports: [
    CommonModule,
    SmashHeaderModule,
    SharedModule,
    RouterModule.forChild(VIEWER_ROUTES),
    StoreModule.forFeature(fromViewer.viewerFeatureKey, fromViewer.reducer),
    EffectsModule.forFeature([ViewerEffects]),
    SmashFormsModule,
    SmashPlayerModule,
    SmashImageModule,
    SmashScrollbarModule,
    SmashSwipperModule,
    SmashPromotionModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    },
  ]
})
export class ViewerModule { }
